/* Catalog-only controls. Native Shopify product pages own variants and cart forms. */
(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-pp-catalog]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const grid = root.querySelector('[data-grid]');
      const cards = [...grid.querySelectorAll('[data-card]')];
      const systemButtons = [...root.querySelectorAll('button[data-system]')];
      const categoryButtons = [...root.querySelectorAll('button[data-category]')];
      const labels = Object.fromEntries(categoryButtons.map(b => [b.dataset.category, b.querySelector(':scope > span:last-child')?.textContent || b.textContent]));
      const sortSelect = root.querySelector('[data-sort]');
      const dialog = root.querySelector('[data-identify]');
      let system = 'all', category = 'all', trigger;
      function render() {
        const visible = cards.filter(card => {
          const d = card.dataset;
          return (system === 'all' || d.system === system || d.system === 'shared') &&
            (category === 'all' || d.categories.split(' ').includes(category));
        });
        const ordered = [...cards];
        if (sortSelect.value === 'name') ordered.sort((a,b) => a.dataset.name.localeCompare(b.dataset.name));
        if (sortSelect.value.startsWith('price-')) ordered.sort((a,b) => {
          // Prelaunch entries have no invented price and always sort last.
          const x = a.dataset.price, y = b.dataset.price;
          if (x === undefined || y === undefined) return x === y ? 0 : x === undefined ? 1 : -1;
          return (Number(x) - Number(y)) * (sortSelect.value === 'price-low' ? 1 : -1);
        });
        const matching = new Set(visible);
        ordered.forEach(card => { card.hidden = !matching.has(card); grid.append(card); });
        systemButtons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.system === system)));
        categoryButtons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.category === category)));
        const systemLabel = system === 'all' ? '' : system.toUpperCase();
        root.querySelector('[data-results-title]').textContent = systemLabel
          ? (category === 'all' ? 'Products for ' + systemLabel : labels[category] + ' for ' + systemLabel)
          : labels[category];
        const upcoming = visible.filter(c => c.hasAttribute('data-prelaunch')).length;
        const available = visible.length - upcoming;
        root.querySelector('[data-result-count]').textContent = `${available} ${available === 1 ? 'product' : 'products'}${upcoming ? ` + ${upcoming} coming soon` : ''}`;
        root.querySelector('[data-empty]').hidden = visible.length > 0;
      }
      function revealMobileResults(force = false) {
        if (!force && !window.matchMedia('(max-width: 760px)').matches) return;
        requestAnimationFrame(() => {
          const results = root.querySelector('.pp-catalog-results-head');
          const header = document.getElementById('shopify-section-header');
          results.style.scrollMarginTop = ((header?.getBoundingClientRect().height || 0) + 16) + 'px';
          results.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            block: 'start'
          });
        });
      }
      function chooseSystem(next) {
        system = next;
        if ((system === 'core' && category === 'classic-addons') || (system === 'classic' && category === 'core-addons')) category = 'all';
        render();
      }
      systemButtons.forEach(b => b.addEventListener('click', () => {
        const shortcut = b.hasAttribute('data-model-shortcut');
        if (shortcut) category = 'all';
        chooseSystem(b.dataset.system);
        revealMobileResults(shortcut);
        if (shortcut) {
          const heading = root.querySelector('[data-results-title]');
          heading.tabIndex = -1;
          heading.focus({preventScroll: true});
        }
      }));
      // Keep the photo link intact; the independent corner button only changes photos.
      cards.forEach(card => {
        const media = card.querySelector('.pp-catalog-card-image');
        if (!media || !media.querySelector('.pp-catalog-hover')) return;
        const wrap = document.createElement('div');
        wrap.className = 'pp-catalog-photo-wrap';
        media.before(wrap); wrap.append(media);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'pp-catalog-photo-toggle';
        const label = 'Show lifestyle photo for ' + card.dataset.name;
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-pressed', 'false');
        button.title = label;
        button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="4" width="18" height="16" rx="3"/><circle cx="8" cy="9" r="1.5"/><path d="m4 17 5-5 4 4 3-3 4 4"/></svg>';
        button.addEventListener('click', () => {
          const shown = media.dataset.photo !== 'lifestyle';
          media.dataset.photo = shown ? 'lifestyle' : 'product';
          button.setAttribute('aria-pressed', String(shown));
          button.title = shown ? 'Show product photo for ' + card.dataset.name : label;
          button.setAttribute('aria-label', button.title);
        });
        wrap.append(button);
      });
      categoryButtons.forEach(b => b.addEventListener('click', () => { category = b.dataset.category; render(); revealMobileResults(); }));
      sortSelect.addEventListener('change', render);
      root.querySelector('[data-reset]').addEventListener('click', () => { system = category = 'all'; sortSelect.value = 'featured'; render(); });
      const dialogs = [...root.querySelectorAll('dialog')];
      function openDialog(modal, button) {
        trigger = button;
        modal.showModal();
      }
      dialogs.forEach(modal => {
        modal.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', () => modal.close()));
        modal.addEventListener('close', () => trigger?.focus());
        modal.addEventListener('click', e => {
          if (e.target !== modal) return;
          const r = modal.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) modal.close();
        });
      });
      root.querySelectorAll('[data-open-identify]').forEach(b => b.addEventListener('click', () => openDialog(dialog,b)));
      root.querySelectorAll('[data-open-compare]').forEach(b => b.addEventListener('click', () => openDialog(root.querySelector('[data-compare]'),b)));
      root.querySelectorAll('[data-pick]').forEach(b => b.addEventListener('click', () => { category = 'all'; chooseSystem(b.dataset.pick); dialog.close(); revealMobileResults(); }));
      const quiz = root.querySelector('[data-quiz]');
      if (quiz) {
        let step = 1, answers = {};
        const steps = [...quiz.querySelectorAll('.quiz-step')];
        const options = [...quiz.querySelectorAll('.quiz-option')];
        const results = quiz.querySelector('.quiz-result');
        const list = quiz.querySelector('[data-quiz-results]');
        const progress = quiz.querySelector('[data-quiz-progress]');
        const label = quiz.querySelector('[data-quiz-label]');
        function showStep(n, focus = true) {
          step = n;
          steps.forEach(el => { el.hidden = Number(el.dataset.step) !== n; });
          results.hidden = true;
          quiz.querySelector('.quiz-nav').hidden = false;
          quiz.querySelector('.quiz-back').hidden = n === 1;
          label.textContent = `Step ${n} of 4`;
          progress.style.width = `${n * 25}%`;
          options.forEach(b => {
            const selected = answers[b.dataset.question] === b.dataset.answer;
            b.classList.toggle('selected', selected);
            b.setAttribute('aria-pressed', String(selected));
          });
          if (focus) {
            const heading = steps[n-1].querySelector('h2');
            heading.tabIndex = -1; heading.focus();
          }
        }
        function reset() { answers = {}; showStep(1); }
        function recommend() {
          const a = answers, scores = {CORE:0,MEGA:0,PREMIUM:0,STANDARD:0,SMALL:0,MINI:0};
          const add = values => Object.entries(values || {}).forEach(([k,v]) => scores[k] += v);
          add({small:{CORE:2,SMALL:3,MINI:1},medium:{CORE:3,STANDARD:1,SMALL:1},large:{CORE:3,MEGA:1,STANDARD:1},xl:{CORE:5,MEGA:2},multi:{MEGA:7,CORE:1}}[a.dog]);
          add({balcony:{CORE:4,STANDARD:1,SMALL:1,PREMIUM:1},patio:{CORE:3,PREMIUM:3,STANDARD:1,SMALL:1,MEGA:1},indoor:{CORE:6,STANDARD:2,SMALL:2,PREMIUM:-20,MEGA:-5},travel:{MINI:100,CORE:1,STANDARD:1}}[a.place]);
          add({basin:{CORE:5,STANDARD:1,SMALL:1},away:{CORE:3,STANDARD:2,SMALL:2,MEGA:2},rinse:{PREMIUM:a.place==='indoor'?-20:7,CORE:1},unsure:{CORE:5}}[a.waste]);
          add({easy:{CORE:5},polished:{CORE:5},room:{MEGA:7,CORE:1},value:{STANDARD:4,SMALL:a.dog==='small'?5:3}}[a.priority]);
          // Compact models must not be recommended for a large dog solely on cost/travel.
          const eligible = Object.keys(scores).filter(k => {
            if (['MINI','SMALL'].includes(k) && a.dog !== 'small') return false;
            if (a.dog === 'xl' && k !== 'CORE') return false;
            if (k === 'PREMIUM' && a.place === 'indoor') return false;
            if (k === 'MINI' && a.waste === 'away') return false;
            return true;
          });
          eligible.sort((x,y) => scores[y]-scores[x]);
          const max = Math.max(...eligible.map(k=>scores[k]));
          let matches = eligible.filter(k => scores[k]>0 && scores[k]>=max*.45);
          if (matches.includes('CORE')) matches = ['CORE',...matches.filter(k=>k!=='CORE')];
          const names = {CORE:'CORE',MEGA:'CLASSIC Mega',PREMIUM:'CLASSIC Premium',STANDARD:'CLASSIC Standard',SMALL:'CLASSIC Small',MINI:'CLASSIC Mini'};
          const reasons = {
            CORE:'Two included drainage options and a customizable wrap. Supports up to 150 lbs.',
            MEGA:'Sixteen square feet of grass area for extra room. Catch basins sold separately.',
            PREMIUM:'Built-in pop-up sprinklers for outdoor rinsing. Catch basin sold separately.',
            STANDARD:'Full-size pour-over system. Catch basin sold separately.',
            SMALL:'Compact 26-inch square footprint. Catch basin sold separately.',
            MINI:'Low-profile 25 × 16-inch tray for small dogs. Synthetic grass sold separately.'
          };
          list.replaceChildren();
          matches.forEach(key => {
            const source = cards.find(c => c.dataset.name === names[key]);
            if (!source) return;
            const article = document.createElement('article'); article.className='quiz-result-card';
            const photo = source.querySelector('.pp-catalog-primary').cloneNode();
            photo.removeAttribute('class'); photo.loading='lazy'; article.append(photo);
            const copy=document.createElement('div'); copy.className='quiz-result-copy';
            const kicker=document.createElement('small'); kicker.textContent=key==='CORE'?'Explore CORE':'Also consider';
            const h=document.createElement('h3'); h.textContent=names[key];
            const p=document.createElement('p'); p.textContent=reasons[key];
            copy.append(kicker,h,p);
            if(key==='CORE') {
              const swatches=source.querySelector('.pp-catalog-swatches');
              if(swatches) copy.append(swatches.cloneNode(true));
            }
            const link=source.querySelector('.pp-catalog-cta');
            if(link) copy.append(link.cloneNode(true));
            else {const notice=document.createElement('p');notice.textContent='Launching with the new site';copy.append(notice);}
            article.append(copy);list.append(article);
          });
          steps.forEach(el=>el.hidden=true); results.hidden=false;
          quiz.querySelector('.quiz-nav').hidden=true;
          label.textContent=`${list.children.length} ${list.children.length === 1 ? 'match' : 'matches'}`;progress.style.width='100%';
          const h=results.querySelector('h2');h.tabIndex=-1;h.focus();
        }
        options.forEach(b=>b.addEventListener('click',()=>{
          answers[b.dataset.question]=b.dataset.answer;
          if(step===4) recommend(); else showStep(step+1);
        }));
        quiz.querySelector('.quiz-back').addEventListener('click',()=>showStep(Math.max(1,step-1)));
        quiz.querySelector('.quiz-restart').addEventListener('click',reset);
        root.querySelectorAll('[data-open-quiz]').forEach(b=>b.addEventListener('click',()=>{openDialog(quiz,b);reset();}));
      }
      const hashCategories = {'#porch-potties':'potties','#add-ons':'classic-addons','#grass-options':'grass-care','#other':'other','#subscriptions-1':'subscriptions'};
      function applyHashCategory() {
        const hashCategory = hashCategories[window.location.hash];
        if (!hashCategory) return;
        category = hashCategory;
        render();
      }
      applyHashCategory();
      window.addEventListener('hashchange', applyHashCategory);
      render();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
